angular.module('eCareVault.common.directives').directive('dateAutoFormat', function () {
    return { 
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            //To add '/' automaticaly when user enters digits for the date
            ctrl.$validators.dateAutoFormat = function (modelValue, viewValue)
            {
                if(viewValue){
                    const inputElement = elm[0] as HTMLInputElement;
                    let position = inputElement.selectionStart;
                    let digits = ('' + viewValue).replace(/\D/g, '');
                    if (digits.length >= 2) {
                        digits = digits.slice(0, 2) + '/' + digits.slice(2);
                    }
                    if (digits.length >= 5) {
                        digits = digits.slice(0, 5) + '/' + digits.slice(5);
                    }
                    ctrl.$setViewValue(digits);
                    ctrl.$render();
                    //If user updates the digits in between then after render the cursor moves to the end.
                    //So resetting the cursor to the same position.
                    if(position == 2 || position == 5){  //increasing the position to handle the added slash
                        position++;
                    }
                    inputElement.setSelectionRange(position, position);
                }
                return true;
            };

            //To handle backspace
            elm.bind('keydown', function(event) {
                const key = event.which || event.keyCode;
                if (key === 8) { // Backspace key
                    const inputElement = elm[0] as HTMLInputElement;
                    const value = inputElement.value;
                    const position = inputElement.selectionStart;
                    //If the char to be deleted is '/' then clear the digit adjacent to it together with the '/'
                    if (position > 0 && value[position - 1] === '/') {
                        event.preventDefault();
                        const newValue = value.slice(0, position - 2) + value.slice(position);
                        ctrl.$setViewValue(newValue);
                        ctrl.$render();
                        inputElement.setSelectionRange(position - 2, position - 2);
                    } 
                }
            });
        }
    };
});
